import { httpClient } from 'utils/httpClient';
import { FcmConfig, FcmPayload, FcmTestResult } from 'types/fcm.types';

export const fcmService = {
  async get(): Promise<FcmConfig> {
    return httpClient.get<FcmConfig>('/fcm');
  },
  async update(payload: FcmPayload): Promise<FcmConfig> {
    return httpClient.put<FcmConfig>('/fcm', payload);
  },
  async test(): Promise<FcmTestResult> {
    return httpClient.post<FcmTestResult>('/fcm/test', {});
  },
};
